export default __webpack_public_path__ + "static/media/softdrinks.438a98e1.jpg";